import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/ViewProductValidationMaster';


const ViewProductValidationMaster = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Product Validation MASTER - View</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

ViewProductValidationMaster.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ViewProductValidationMaster);
